import { BATTERY_LIFECYCLE_STATUSES } from '../../constants';

import { WithPopover } from '@american-autonomy/ag-ui';

import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import BatteryLifecyclePill from './components/BatteryLifecyclePill';
import BatteryStatusMenu from './components/BatteryStatusMenu';
import { TEST_ID } from './constants';
import type { FunctionComponent, LifecycleLabelMap, Props } from './types';

import styles from './styles.module.scss';

const BatteryStatusControl: FunctionComponent<Props> = ({
    batteryId,
    className = '',
    isAdmin,
    onSetStatus,
    status,
    testId = TEST_ID
}) => {
    const t = useTranslation();
    const lifecycleLabels: LifecycleLabelMap = {
        hold: t.BATTERY_STATUS_HOLD,
        'in-service': t.BATTERY_STATUS_IN_SERVICE,
        retired: t.BATTERY_STATUS_RETIRED
    };
    const handleStop = (clickEvent: { stopPropagation: VoidFunction }) =>
        clickEvent.stopPropagation();
    const pill = <BatteryLifecyclePill label={lifecycleLabels[status]} status={status} />;

    return (
        <div
            className={`${styles.batteryStatusControl} ${className}`}
            data-testid={testId}
            onClick={handleStop}>
            {isAdmin ? (
                <WithPopover className={styles.popover} trigger={pill}>
                    <BatteryStatusMenu
                        lifecycleLabels={lifecycleLabels}
                        onSelect={selected => onSetStatus({ batteryId, status: selected })}
                        statuses={BATTERY_LIFECYCLE_STATUSES}
                    />
                </WithPopover>
            ) : (
                pill
            )}
        </div>
    );
};

export default BatteryStatusControl;
